import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import { useStateService } from '@/shared/services/StateService';
import messages from '../readinessMessages';
import { profileName, templateName } from '../readinessNames';
import CustomerList from './CustomerList';
import ReadinessGroup from './ReadinessGroup';
const ScheduleSection = ({ issues, checkedCount }) => {
    const intl = useIntl();
    const stateService = useStateService();
    const [search, setSearch] = useState('');
    const groups = useMemo(() => {
        const byKey = new Map();
        issues
            .filter(issue => issue.relationName.toLowerCase().includes(search.toLowerCase()))
            .forEach(issue => {
            var _a;
            const profiles = [...issue.missingProfiles].sort();
            const key = `${issue.taskTemplateId}|${profiles.join(',')}`;
            if (!byKey.has(key))
                byKey.set(key, {
                    key,
                    taskTemplateId: issue.taskTemplateId,
                    templateName: templateName(intl, issue.taskTemplateId, issue.templateName),
                    attention: profiles.length > 0
                        ? `${intl.formatMessage(messages.ColMissingRole)}: ${profiles
                            .map(p => profileName(intl, p))
                            .join(', ')}`
                        : intl.formatMessage(messages.MissingAssignment),
                    issues: [],
                });
            (_a = byKey.get(key)) === null || _a === void 0 ? void 0 : _a.issues.push(issue);
        });
        return [...byKey.values()].sort((a, b) => b.issues.length - a.issues.length);
    }, [issues, search, intl]);
    if (checkedCount === 0)
        return _jsx("p", Object.assign({ className: "text-muted" }, { children: intl.formatMessage(messages.NoScheduledTasks) }));
    if (issues.length === 0)
        return (_jsx("p", Object.assign({ className: "readiness-all-ok" }, { children: intl.formatMessage(messages.AllScheduledTasksAssigned) })));
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "inline-row" }, { children: _jsx("input", { type: "text", className: "form-control search-input", placeholder: intl.formatMessage(messages.SearchCustomer), value: search, onChange: e => setSearch(e.target.value) }) })), groups.map(group => (_jsx(ReadinessGroup, Object.assign({ title: group.templateName, detail: group.attention, count: intl.formatMessage(messages.Customers, { count: group.issues.length }), action: _jsx("a", Object.assign({ href: stateService.getStateUrl('settings.taskTemplates', {
                        templateId: group.taskTemplateId,
                    }), title: intl.formatMessage(messages.OpenTaskTemplates), "aria-label": intl.formatMessage(messages.OpenTaskTemplates) }, { children: _jsx("i", { className: "fa fa-external-link" }) })) }, { children: _jsx(CustomerList, { detailHeader: intl.formatMessage(messages.ColAttention), rows: group.issues
                        .slice()
                        .sort((a, b) => a.relationName.localeCompare(b.relationName))
                        .map(issue => ({
                        key: `${issue.relationId}|${issue.taskTemplateId}`,
                        relationId: issue.relationId,
                        relationName: issue.relationName,
                        detail: group.attention,
                    })) }) }), group.key)))] }));
};
export default ScheduleSection;
